import { render, staticRenderFns } from "./SliderBuyOnlineSingleBox.vue?vue&type=template&id=fccf4e7c&scoped=true&"
import script from "./SliderBuyOnlineSingleBox.vue?vue&type=script&lang=js&"
export * from "./SliderBuyOnlineSingleBox.vue?vue&type=script&lang=js&"
import style0 from "./SliderBuyOnlineSingleBox.vue?vue&type=style&index=0&id=fccf4e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccf4e7c",
  null
  
)

component.options.__file = "SliderBuyOnlineSingleBox.vue"
export default component.exports